import { api } from '../config'

export const USER_URL = {
  login: `${api.withAPI}administrative/api/v1/admin/auth/login`,
  get_user: `${api.withAPI}administrative/api/v1/admin/admin/profile`,
  forgot_password: `${api.withAPI}administrative/api/v1/admin/auth/forgot-password`,
  change_password: `${api.withAPI}administrative/api/v1/admin/auth/change-password`,
}
